import EzController from 'controllers/ez-base-controller';
import { trackCompleteEvent, findCategoryByElement, TrackingData } from 'components/analytics/conversions/tracking';

type EventParams = {
  action?: string,
  category?: string,
  label?: string,
  value?: string,
  params: Record<string, unknown>
};

export default class TrackCompleteEventController extends EzController {
  track(event: { target: HTMLElement, params: EventParams }) {
    const {
      action,
      category,
      label,
      value,
      ...params
    }: EventParams = event.params;

    if (action === undefined) return;

    const payload: TrackingData = {
      action,
    };

    if (label !== undefined) payload.label = label;
    if (value !== undefined) payload.value = value;

    if (category === undefined) {
      payload.category = findCategoryByElement(event.target);
    } else {
      payload.category = category;
    }

    Object.assign(payload, params);

    trackCompleteEvent(payload);
  }
}
